import { Button, Row, Space, Tooltip, Typography } from 'antd';

import { PREFIX } from '@app/constants/appPrefix';

import '@pages/Clients/ClientsList/styles/Filters.desktop.scss';
import '@pages/Clients/ClientsList/styles/Filters.tablet.scss';
import { useFilters } from '@pages/Clients/ClientsList/hooks';

const { Text } = Typography;

export const Filters = () => {
  const {
    filterGroupsComponent,
    generateLeadsSegment,
    generateSegmentWithTwoGroups,
    generateSegmentNewData,
    generateSegmentRepeatedData,
    generateSegmentLostData,
  } = useFilters();

  return (
    <div className={`${PREFIX}client-filters`}>
      <Space direction="vertical">
        <Row align="middle">
          <Text style={{ fontWeight: 600 }}>Сегменты:</Text>

          <Tooltip title="Клиенты, у которых нет записей">
            <Button type="link" onClick={generateLeadsSegment}>
              Лиды
            </Button>
          </Tooltip>
          <Tooltip title="Новые клиенты, которые пришли к вам за последний месяц">
            <Button
              type="link"
              onClick={() =>
                generateSegmentWithTwoGroups(generateSegmentNewData)
              }
            >
              Новые
            </Button>
          </Tooltip>
          <Tooltip title="Клиенты, которые совершили повторный визит за последний месяц">
            <Button
              type="link"
              onClick={() =>
                generateSegmentWithTwoGroups(generateSegmentRepeatedData)
              }
            >
              Повторные
            </Button>
          </Tooltip>
          <Tooltip title="Клиенты без визитов на протяжении последних 60 дней">
            <Button
              type="link"
              onClick={() =>
                generateSegmentWithTwoGroups(generateSegmentLostData)
              }
            >
              Потерянные
            </Button>
          </Tooltip>
        </Row>

        <Row align="middle">
          <Space className="filters-container" size="middle" align="start">
            <Text className="filters-title">Фильтры:</Text>

            <Space direction="vertical">{filterGroupsComponent}</Space>
          </Space>
        </Row>
      </Space>
    </div>
  );
};
